<template>
    <div class="alert-container">
            <alert v-for="(alert, index) in alerts" :type="alert.type" :key="index" :auto-close="alert.autoClose"
                   class="mr-2">
                <span v-html="alert.message"/>
            </alert>
    </div>
</template>

<script>
import Alert from "./Alert"

export default {
    name: "AlertContainer",

    components: {Alert},

    data() {
        return {
            alerts: [],
        }
    },

    computed: {},

    mounted() {
        this.alerts = this.$_alerts
    },

    methods: {},
}
</script>

<style>
.alert-container {
    position: fixed;
    bottom: 0;
    right: 0;

    width: calc(100% - 8px);
    max-width: 500px;


    z-index:9999;
    background: transparent;
}
</style>
